import React from 'react';
import PageLines from './PageLines';
import { LargePageLineText } from './PageLineText';

const GroupedPageLines = ({
  children,
  top = 0,
  width = 750,
  fontSize,
  color,
  marginLeftText,
  marginTopText,
  marginPageLines,
  fontFamily,
  isNarrow,
  isWide,
  paddingTop
}: any) => (
  <PageLines
    width={width}
    className="groupedLines"
    isNarrow={isNarrow}
    isWide={isWide}
    paddingTop={paddingTop}
    style={{
      alignSelf: 'center',
      margin: marginPageLines ?? '10px 25px 45px',
      position: 'relative',
      top,
      left: 0
    }}
  >
    <LargePageLineText
      style={{
        justifyContent: 'space-between',
        width: 514,
        marginLeft: marginLeftText ?? 20,
        fontSize: fontSize || 52,
        marginTop: marginTopText ?? '-24px',
        color: color || '#767676',
        fontFamily: fontFamily || 'Print-Wide-Book',
        letterSpacing: 'unset'
      }}
    >
      {children}
    </LargePageLineText>
  </PageLines>
);

export default GroupedPageLines;
